<template>
  <div>
    <Form ref="searchForm" inline :label-width="70" class="search-form">
      <Form-item label="资讯名称">
        <Input style="width:200px" placeholder="请输入资讯名称关键字" v-model="searchCondition.keywords" clearable />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/information"
        method="get"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="id"
        :selectedItems="selectedItems"
        keepSelected
      ></Grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseSelect",
  data() {
    return {
      columns: [
        {
          title: "资讯名称",
          key: "title"
        },
        {
          title: "所属分类",
          key: "classify"
        }
      ],
      selectList: [],
      searchCondition: {
        keywords: "",
        status: 1
      }
    };
  },
  props: {
    selectedItems: {
      type: Array
    },
    selectType: {
      type: String,
      default: "multi"
    }
  },
  methods: {
    rowsFormatter() {
      // rows.forEach(i => {});
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.keywords = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onSelectionChange(val) {
      this.selectList = [...val];
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    },
  }
};
</script>
<style lang="scss" scoped>
</style>